import React, { useEffect, useState } from 'react'
import Line3 from "../../../assets/images/line3.png"
import Quote from "../../../assets/images/quote.png"
import User1 from "../../../assets/images/users/user1.jpg"
import User2 from "../../../assets/images/users/user2.jpg"
import User3 from "../../../assets/images/users/user3.jpg"
import Slider from 'react-slick'
import Testi from "../../../assets/images/testi.png"
import BigBall from "../../../assets/images/big-ball.png"
import Dots from "../../../assets/images/dot-shape.png"
import Triangle from "../../../assets/images/triangle.png"
import { axiosInstance } from '../config'

const Testimonial = () => {

    const settings = {
        dots: true,
        fade: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        waitForAnimate: false,
        arrows: false,
        autoplay: true,
    };

    const [testimonial, settestimonial] = useState([])

    useEffect(() => {
        window.scroll(0, 0);
        getData();
    }, [])

    const getData = async () => {
        axiosInstance.get(`/testimonials`)
            .then(res => {
                settestimonial(res?.data?.Testimonial);  // Set the modified services with icons
            })
            .catch((err) => console.log(err))
            .finally(() => {
            });
    }

    return (
        <div>
            <div className="rs-testimonial testimonial-style1 bg7 pt-75">
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-6 pl-50 md-pl-15 mt--83 md-mt--0 md-mb-50 order-last">
                            <div className="sec-title mb-45">
                                <span className="sub-text green-color yellow-color">Testimonials</span>
                                <h2 className="title pb-10 white-color">
                                    Our Clients<span className="yellow-color"> Reviews</span>
                                </h2>
                                <div className="line-img testi-center wow fadeInUp" >
                                    <img src={Line3} alt="Images" />
                                </div>
                                <div className="desc white-color">
                                    We are also proud to say that we are the only cleaning service to have an exclusive partnership with the trusted
                                </div>
                            </div>
                            <Slider {...settings} >
                                {testimonial?.map((test, i) => {
                                    return (
                                        <div className="testi-item">
                                            <div className="author-desc">
                                                <div className="desc">
                                                    <img className="quote d-md-inline d-none" src={Quote} alt="" />
                                                    {test?.description}
                                                </div>
                                            </div>
                                            <div className="testimonial-content">
                                                <div className="testi-img">
                                                    <img src={test?.imageUrl} alt="" />
                                                </div>
                                                <div className="testi-information" style={{ flex: 1 }}>
                                                    <div className="testi-information">
                                                        <div className="testi-name">{test?.name}</div>
                                                        <span className="designation">{test?.services?.name}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </Slider>
                        </div >

                        <div className="col-lg-6 pl-60 md-pl-15">
                            <div className="testi-image">
                                <div className="main-img text-center">
                                    <img src={Testi} alt="Images" />
                                </div>
                                <div className="testi-anaimation">
                                    <div className="animate big-ball">
                                        <img className="scale" src={BigBall} alt="Images" />
                                    </div>
                                    <div className="animate dot-shape">
                                        <img className="scale" src={Dots} alt="Images" />
                                    </div>
                                    <div className="animate triangle">
                                        <img className="horizontal" src={Triangle} alt="Images" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div >
                </div >
            </div >
        </div >
    )
}

export default Testimonial
